//# sourceMappingURL=modal.mjs.map
/// <reference types="./modal.d.mts" />
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $dom from "../../../redraw_dom/redraw/dom.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $context from "../../../redraw_unsafe/redraw/unsafe/context.mjs";
import {
  Ok,
  Error,
  prepend as listPrepend,
  CustomType as $CustomType,
  makeError,
} from "../../gleam.mjs";

const FILEPATH = "src/ds/providers/modal.gleam";

export class Empty extends $CustomType {}
export const State$Empty = () => new Empty();
export const State$isEmpty = (value) => value instanceof Empty;

export class State extends $CustomType {
  constructor(content, resolve) {
    super();
    this.content = content;
    this.resolve = resolve;
  }
}
export const State$State = (content, resolve) => new State(content, resolve);
export const State$isState = (value) => value instanceof State;
export const State$State$content = (value) => value.content;
export const State$State$0 = (value) => value.content;
export const State$State$resolve = (value) => value.resolve;
export const State$State$1 = (value) => value.resolve;

export class Modal extends $CustomType {
  constructor(open, close) {
    super();
    this.open = open;
    this.close = close;
  }
}
export const Modal$Modal = (open, close) => new Modal(open, close);
export const Modal$isModal = (value) => value instanceof Modal;
export const Modal$Modal$open = (value) => value.open;
export const Modal$Modal$0 = (value) => value.open;
export const Modal$Modal$close = (value) => value.close;
export const Modal$Modal$1 = (value) => value.close;

export class Props extends $CustomType {
  constructor(on_end) {
    super();
    this.on_end = on_end;
  }
}
export const Props$Props = (on_end) => new Props(on_end);
export const Props$isProps = (value) => value instanceof Props;
export const Props$Props$on_end = (value) => value.on_end;
export const Props$Props$0 = (value) => value.on_end;

const context_name = "Freyja:Providers:Modal";

function content(state, _) {
  if (state instanceof Empty) {
    return $h.none();
  } else {
    let content$1 = state.content;
    let on_end = state.resolve;
    let props = new Props(on_end);
    let _pipe = content$1(props);
    let _pipe$1 = $dom.create_portal(_pipe, "modal");
    return $result.lazy_unwrap(_pipe$1, $h.none);
  }
}

function cancel_previous_modal(state) {
  if (state instanceof Empty) {
    return undefined;
  } else {
    return state.resolve(new Error(undefined));
  }
}

function close(set_state) {
  return set_state(
    (state) => {
      cancel_previous_modal(state);
      return new Empty();
    },
  );
}

function open(content, set_state) {
  return $promise.new$(
    (resolve) => {
      return set_state(
        (state) => {
          cancel_previous_modal(state);
          return new State(
            content,
            (result) => {
              set_state((_) => { return new Empty(); });
              return resolve(result);
            },
          );
        },
      );
    },
  );
}

function use_modal_context() {
  let $ = $redraw.use_state_(new Empty());
  let state = $[0];
  let set_state = $[1];
  let open$1 = $redraw.use_callback(
    (content) => { return open(content, set_state); },
    [],
  );
  let close$1 = $redraw.use_callback(() => { return close(set_state); }, []);
  let ctx = $redraw.use_memo(() => { return new Modal(open$1, close$1); }, []);
  return $redraw.use_memo(() => { return [state, ctx]; }, [state]);
}

function default_value() {
  let open$1 = (_) => { return $promise.resolve(new Error(undefined)); };
  let close$1 = () => { return undefined; };
  return new Modal(open$1, close$1);
}

export function provider() {
  let context = $context.context(context_name, default_value);
  return $redraw.component_(
    "Freyja.Providers(Modal)",
    (children) => {
      let $ = use_modal_context();
      let state = $[0];
      let modal = $[1];
      return $redraw.provider(
        context,
        modal,
        listPrepend(content(state, modal), children),
      );
    },
  );
}

export function use_modal() {
  let $ = $context.get(context_name);
  let context;
  if ($ instanceof Ok) {
    context = $[0];
  } else {
    throw makeError(
      "let_assert",
      FILEPATH,
      "ds/providers/modal",
      37,
      "use_modal",
      "Pattern match failed, no pattern matched the value.",
      { value: $, start: 875, end: 925, pattern_start: 886, pattern_end: 897 }
    )
  }
  return $redraw.use_context(context);
}
